import ClassicExtension from "./ClassicExtension";

/**
 * Put the input range value to the output element by id in data-output attribute
 */
export default class InputRangeOutputExtension extends ClassicExtension {

    protected init($root: JQuery) {
        $root.find('input[type="range"][data-output]')
            .each((i, input: HTMLInputElement) => {
                const outputId = input.dataset.output;
                if (!outputId) {
                    return;
                }

                const output = document.getElementById(outputId);
                input.addEventListener('input', () => this.updateOutputValue(input, output));

                this.updateOutputValue(input, output);
            })
        ;
    }

    private updateOutputValue(input: HTMLInputElement, output: HTMLElement,): void {
        output.textContent = input.value ?? '';
    }

}
